<template>
  <div id="product-order-details-view" class="vx-row">
    <div class="vx-col w-full">
      <vx-card v-if="dataLoaded" :title="orderDetails.product_order_code">
        <template slot="actions">
          <div class="flex items-center">
            <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-chevron-down" icon-after>
                Actions
              </vs-button>

              <vs-dropdown-menu class="w-64">
                <vs-dropdown-item
                  v-if="!isOneItemInDispatchedStatus && $can('create-edit-order')"
                  @click="onClickProductOrderUpdate(orderDetails.id, orderDetails.customer.id)">
                  Update Order & Address
                </vs-dropdown-item>
                <vs-dropdown-item
                  @click="onClickCreateCreditNote()">
                  Create Credit Note
                </vs-dropdown-item>
                <vs-dropdown-item
                  @click="sendOrderConfirmation">
                  {{ confirmationEmailAlreadySent ? 'Resend Order Confirmation ' : 'Send Order Confirmation ' }}
                </vs-dropdown-item>
                <vs-dropdown-item
                  v-if="confirmationEmailAlreadySent"
                  @click="viewConfirmationSentLog">
                  View Confirmation Sent Log
                </vs-dropdown-item>
                <vs-dropdown-item
                  v-if="$can('create-edit-order')"
                  @click="onClickCloneProductOrder()">
                  Clone SO
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-button @click="onClickBack" color="primary" type="filled">Back to orders</vs-button>
          </div>
        </template>

        <div class="vx-row md:mb-3 mt-8">
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="UserIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span @click.stop="onClickViewCustomer()" class="text-md text-primary cursor-pointer">
                                <h5 class="mb-2">Customer</h5>
                                {{ orderDetails.customer.company_name }} <br>
                                {{ orderDetails.customer.account_number || 'N/A'}} <br/>

                                <vs-chip :color="customerStatusColorFactory(orderDetails.customer.status.id)" class="mt-3">{{ orderDetails.customer.status.name || 'N/A'}}</vs-chip>

                            </span>
              </vs-col>
            </vs-row>
          </div>

          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="BoxIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-all">
                                <h5 class="mb-2">Customer PO number</h5>
                                {{ orderDetails.customers_order_number || 'N/A'}}
                            </span>
              </vs-col>
            </vs-row>
          </div>

          
          <div class="vx-col md:w-1/4 w-full mb-3">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="UserCheckIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-all">
                                <h5 class="mb-2">Ordered by</h5>
                                {{ orderDetails.created_by }}
                            </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="CalendarIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-all">
                                <h5 class="mb-2">Order date</h5>
                                {{ __dateTimeFormatter(orderDetails.created_at) }}
                            </span>
              </vs-col>
            </vs-row>
          </div>
          

<!--          <div class="vx-col md:w-1/4 w-full">-->
<!--            <vs-row vs-type="flex">-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">-->
<!--                <feather-icon icon="RefreshCwIcon" class="text-success cursor-pointer"/>-->
<!--              </vs-col>-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">-->
<!--                            <span class="text-md break-all">-->
<!--                                <h5 class="mb-2">Order Status</h5>-->
<!--                                <vs-chip style="border-radius: 0" class="text-center" transparent-->
<!--                                         :color="orderDetails.is_item_status_handled_individually ? 'dark' :  productOrderStatusColorFactory()">-->
<!--                                    {{-->
<!--                                    orderDetails.is_item_status_handled_individually ? 'PO Ungrouped' : orderDetails.status.name-->
<!--                                  }}-->
<!--                                </vs-chip>-->
<!--                            </span>-->
<!--              </vs-col>-->
<!--            </vs-row>-->
<!--          </div>-->
        </div>

        <div class="vx-row md:mb-3 mt-16">
          <div class="vx-col md:w-1/4 w-full mb-3">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="MapPinIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md">
                                <h5 class="mb-2">Address</h5>
                                {{ orderDetails.name }} <br v-if="orderDetails.name">
                                {{ orderDetails.line1 }} <br v-if="orderDetails.line1">
                                {{ orderDetails.line2 }} <br v-if="orderDetails.line2">
                                {{ orderDetails.line3 }} <br v-if="orderDetails.line3">
                                {{ orderDetails.town_state }} <br>
                                {{ orderDetails.post_code }} <br>
                                {{ orderDetails.country }} <br>
                            </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/4 w-full mb-3">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="TruckIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-words">
                                <h5 class="mb-2">Delivery instructions</h5>
                                <vx-read-more :length="100" :text="orderDetails.delivery_instruction"/>
                            </span>
              </vs-col>
            </vs-row>
          </div>

          <div class="vx-col md:w-1/4 w-full mb-3">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="LockIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-words">
                                <h5 class="mb-2">Notes</h5>
                                <vx-read-more :length="100" :text="orderDetails.note"/>
                            </span>
              </vs-col>
            </vs-row>
          </div>

          
          <div class="vx-col md:w-1/4 w-full mb-3">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="UserCheckIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-all">
                                <h5 class="mb-2">Shipment Date</h5>
                                {{ shipmentDate }}
                            </span>
              </vs-col>
            </vs-row>
          </div>
          


          <div class="vx-col md:w-1/4 w-full mb-3" v-if="orderDetails.sage_product_order_id">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="FileIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-all">
                                <h5 class="mb-2">SAGE order id</h5>
                                <span class="text-danger font-bold text-lg cursor-pointer">{{ orderDetails.sage_product_order_id }}</span>
                            </span>
              </vs-col>
            </vs-row>
          </div>

          <div class="vx-col md:w-1/4 w-full mb-3">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="FileIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-all">
                                <h5 class="mb-2">SO history log</h5>
                                <span class="text-danger font-bold text-lg cursor-pointer">
                                  <vs-button @click.stop="onClickViewLogs" size="small" icon-pack="feather" icon="icon-eye"></vs-button>
                                </span>
                            </span>
              </vs-col>
            </vs-row>
          </div>

          <div class="vx-col md:w-1/4 w-full mb-3">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="FileIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-all">
                                <h5 class="mb-2">SO Status change log</h5>
                                <span class="text-danger font-bold text-lg cursor-pointer">
                                  <vs-button @click.stop="onClickViewItemLogs" size="small" icon-pack="feather" icon="icon-eye"></vs-button>
                                </span>
                            </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/4 w-full mb-3">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="FileIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-all">
                                <h5 class="mb-2">Sales Quote</h5>
                                <span class="text-danger font-bold text-lg cursor-pointer">
                                  <HyperLink :id="orderDetails.sale_quote.id" type="sales-quote">{{ orderDetails.sale_quote.quote_code }}</HyperLink>
                                </span>
                            </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="CalendarIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-all">
                                <h5 class="mb-2">Due date</h5>
                                <span v-if="orderDetails.formulation_items.length === 1">
                                  {{ orderDetails.formulation_items[0].required_by || 'N/A' }}
                                </span>
                                <span v-if="orderDetails.formulation_items.length > 1">
                                  Multiple
                                </span>
                            </span>
              </vs-col>
            </vs-row>
          </div>

<!--          <div class="vx-col md:w-1/4 w-full" v-if="orderDetails.formulation_items.length > 1">-->
<!--            <vs-row vs-type="flex">-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">-->
<!--                <feather-icon icon="SettingsIcon" class="text-success cursor-pointer"/>-->
<!--              </vs-col>-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">-->
<!--                  <span class="text-md break-word">-->
<!--                    <h5 class="mb-2">Do you want to handle each item on this order independently? <br>-->
<!--                    <span class="text-danger text-sm">( If not this <span class="font-bold">PO</span> will be process as a multi-product batch )</span></h5>-->
<!--                    <vs-switch :disabled="orderDetails.formulation_items.length === 1"-->
<!--                               v-on:input="onChangeOrderStatusHandle()"-->
<!--                               v-model="orderDetails.is_item_status_handled_individually"/>-->
<!--                  </span>-->
<!--              </vs-col>-->
<!--            </vs-row>-->
<!--          </div>-->


        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex float-right">
<!--              <vs-dropdown>-->

<!--                <a class="flex items-center" href="#">-->
<!--                  Order Status-->
<!--                  <i class="material-icons"> expand_more </i>-->
<!--                </a>-->

<!--                <vs-dropdown-menu class="w-64">-->

<!--                  <vs-dropdown-item-->
<!--                    v-for="status in product_order_statuses"-->
<!--                    v-bind:key="status.slug"-->
<!--                    v-if="status.before_status.includes(orderDetails.status.name) && status.visible_on_main_status"-->
<!--                    @click="onClickStatusChangeConfirm(orderDetails.id, status.slug)">-->
<!--                    {{ status.label }}-->
<!--                  </vs-dropdown-item>-->

<!--                </vs-dropdown-menu>-->
<!--              </vs-dropdown>-->
            </div>
          </div>
        </div>

      </vx-card>

      <vx-card v-if="dataLoaded" class="mt-8" title="Finished products">
        <template slot="actions">

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-if="isAllItemsInAcceptedStatus && $can('create-edit-order')" @click="onClickStatusChangeConfirm(orderDetails.id, 'pending')"
                       class="ml-auto mt-2" size="small" icon-pack="feather" icon="icon-check">Accept All Items</vs-button>
            <vs-button v-if="$can('create-edit-order')" @click.stop="onClickUpdateOrderItems()" icon-pack="feather" icon="icon-plus"
                       class="ml-4 mt-2" size="small" type="border" color="warning">
              Add/Update items in order
            </vs-button>
          </div>
        </template>
        <div class="vx-row">
          <div class="vx-col w-full md:mb-0">
            <product-order-table
              v-on:refresh="refreshData"
              v-on:statusChangeNotify="getProductOrderDetails()"
              v-bind:id="orderDetails.id"
              v-bind:account_currency="account_currency"
              v-bind:items="orderDetails.formulation_items"
              v-bind:customerId="String(orderDetails.customer.id)"
              v-bind:statusId="orderDetails.status.id"
              v-bind:is_item_status_handled_individually="orderDetails.is_item_status_handled_individually"
              v-bind:is_proforma_account="orderDetails.account_credit_type === 'proforma'"
              v-bind:orderInvoices = orderInvoices
            />
          </div>
        </div>
      </vx-card>

      <div class="vx-row" v-if="dataLoaded">
        <div class="vx-col w-full md:mb-0">
          <vx-card title="Additonal Cost" class="mt-8">
            <vs-table :data="orderDetails.add_costs">

              <template slot="thead">
                <vs-th>NAME/DESCRIPTION</vs-th>
                <vs-th>NOMINAL CODE</vs-th>
                <vs-th>AMOUNT (Excl VAT) in {{ account_currency }}</vs-th>
                <vs-th>VAT PERCENTAGE (%)</vs-th>
                <vs-th>AMOUNT (Incl VAT) in {{ account_currency }}</vs-th>
                <vs-th></vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].sage_nominal_code_id">
                    {{ data[indextr].sage_nominal_code_id || '' }}
                  </vs-td>

                  <vs-td :data="data[indextr].amount">
                    {{ data[indextr].amount }}
                  </vs-td>

                  <vs-td :data="data[indextr].vat_percent">
                    {{ data[indextr].vat_percent }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ Number(tr.amount * (1 + (Number(tr.vat_percent) / 100))).toFixed(2) }}
                  </vs-td>

                  <vs-td>
                     <vx-tooltip text="Remove" position="top">
                                <vs-button @click.prevent="onClickRemoveSOSPopUp(data[indextr].id)"
                                          button="button"
                                          size="small" 
                                          color="danger" 
                                          type="border" 
                                          icon-pack="feather" 
                                          icon="icon-x">
                                  Remove
                                </vs-button>
                              </vx-tooltip>
                  </vs-td>
                </vs-tr>
              </template>

            </vs-table>
          </vx-card>
        </div>
      </div>  

      <div class="vx-row" v-can="'view-invoice'">
        <div class="vx-col w-full md:mb-0">

          <vx-card v-if="dataLoaded" class="mt-8" title="Invoices">

            <h4 v-if="orderDetails.account_credit_type === 'proforma'" class="mb-8 uppercase text-danger text-center">
              {{ orderDetails.account_credit_type }} Account
            </h4>
            <template slot="actions">
              <vs-button v-can="'create-edit-invoice'" @click="onClickCreateInvoice()" icon-pack="feather" icon="icon-plus"  class="mr-4 mt-4 mb-4 ml-auto" color="primary" type="filled" size="small">Create</vs-button>
            </template>

            <vs-table noDataText="No invoices available" stripe :data="orderInvoices">

              <template slot="thead">
                <vs-th>INV NUMBER</vs-th>
                <vs-th>INV DATE</vs-th>
                <vs-th>INV DUE DATE</vs-th>
                <vs-th>INV AMOUNT (Excl tax in {{ account_currency }})</vs-th>
                <vs-th>INV STATUS</vs-th>
                <vs-th>Last Invoice Sent Date</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].number">
                    {{ data[indextr].number }}
                  </vs-td>

                  <vs-td :data="data[indextr].date">
                    {{ data[indextr].date }}
                  </vs-td>

                  <vs-td :data="data[indextr].due_date">
                    {{ data[indextr].due_date }}
                  </vs-td>

                  <vs-td>
                    {{calculateTotalInvoiceAmount(data[indextr].items, data[indextr].add_cost)}}
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip style="border-radius: 0;font-weight: bold;" class="text-center text-xs" transparent :color="invoiceStatusColorFactory(data[indextr].status.name)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    {{data[indextr].last_email_sent_at != "" ? convertDate(data[indextr].last_email_sent_at) : 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].amount">
                    <div class="vx-row">
<!--                      <vx-tooltip class="ml-2" text="View invoice" position="left">-->
<!--                        <vs-button @click.stop="onClickInvoiceView(data[indextr].id)"-->
<!--                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-file"></vs-button>-->
<!--                      </vx-tooltip>-->
                      <vx-tooltip class="ml-2" text="View invoice" position="top">
                        <vs-button @click.stop="onClickInvoiceViewTest(data[indextr].id, data[indextr].status.name, data[indextr].invoice_secret_code, data[indextr].last_email_sent_at)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-file"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'create-edit-invoice'" v-if="['In Draft'].includes(data[indextr].status.name)" class="ml-2" text="Update invoice" position="top">
                        <vs-button @click.stop="onClickUpdateInvoice(data[indextr])"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>

<!--                      <vx-tooltip v-if="['In Draft'].includes(data[indextr].status.name)" class="ml-2" text="Status change to inv sent" position="left">-->
<!--                        <vs-button @click.stop="onClickUpdateInvoiceStatus(data[indextr].id, 'sent')"-->
<!--                                   size="small" color="primary" type="filled" icon-pack="feather" icon="icon-check-circle"></vs-button>-->
<!--                      </vx-tooltip>-->

                      <vx-tooltip v-if="['Sent', 'Overdue'].includes(data[indextr].status.name) || ( data[indextr].customer_account_type === 'proforma' && data[indextr].status.name !== 'Paid')"
                                  class="ml-2" text="Status change to inv paid" position="top">
                        <vs-button @click.stop="onClickConfirmStatusChange(data[indextr].id, 'paid')"
                                   size="small" color="success" type="filled" icon-pack="feather" icon="icon-check"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="shouldShowCancelButton(data[indextr])"
                                  class="ml-2" text="Status change to inv cancel" position="top">
                        <vs-button @click.stop="onClickConfirmStatusChange(data[indextr].id, 'cancel')"
                                   size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if=" data[indextr].last_email_sent_at !== '' " class="ml-2" text="Email log" position="top">
                        <vs-button @click.stop="onClickViewEmailLog(data[indextr].id)" size="small" color="danger" type="border" icon-pack="feather" icon="icon-mail"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="View Invoice Logs" position="top">
                        <vs-button @click.stop="onClickViewInvoiceLogs(data[indextr].id, data[indextr].number)"
                                   size="small" color="danger" type="filled" icon-pack="feather" icon="icon-list"></vs-button>
                      </vx-tooltip>
<!--                      <vx-tooltip v-if="['Sent', 'Cancelled'].includes(data[indextr].status.name)" class="ml-2" text="Status change to inv overdue" position="left">-->
<!--                        <vs-button @click.stop="onClickUpdateInvoiceStatus(data[indextr].id, 'overdue')"-->
<!--                                   size="small" color="warning" type="filled" icon-pack="feather" icon="icon-rotate-ccw"></vs-button>-->
<!--                      </vx-tooltip>-->

                    </div>
                  </vs-td>
                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-4/5">
                      <vs-table :data="data[indextr].items">

                        <template slot="header">
                          <h5 class="mb-4">Invoice items</h5>
                        </template>

                        <template slot="thead">
                          <vs-th>ITS PRODUCT CODE</vs-th>
                          <vs-th>ITS PRODUCT NAME</vs-th>
                          <vs-th>NOMINAL CODE</vs-th>
                          <vs-th>SAGE DEPARTMENT</vs-th>
                          <vs-th>QUANTITY (KG)</vs-th>
                          <vs-th>UNIT PRICE (KG/{{ account_currency }})</vs-th>
                          <vs-th>AMOUNT (Excl VAT) in {{ account_currency }}</vs-th>
                          <vs-th>AMOUNT (Incl VAT) in {{ account_currency }}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :key="index_inv" v-for="(tr_inv, index_inv) in data">

                            <vs-td :data="tr_inv.formulation_code">
                              {{ tr_inv.formulation_code }}
                            </vs-td>

                            <vs-td :data="tr_inv.formulation_name">
                              {{ tr_inv.formulation_name }}
                            </vs-td>

                            <vs-td>
                              {{ tr_inv.sage_nominal_code.code || 'N/A' }}
                            </vs-td>

                            <vs-td>
                              {{ tr_inv.sage_department.name || 'N/A' }}
                            </vs-td>

                            <vs-td :data="tr_inv.quantity">
                              {{ tr_inv.quantity }}
                            </vs-td>

                            <vs-td :data="tr_inv.price">
                              {{ tr_inv.price }}
                            </vs-td>

                            <vs-td :data="tr_inv.amount_ex_vat">
                              {{ tr_inv.amount_ex_vat }}
                            </vs-td>

                            <vs-td :data="tr_inv.amount_in_vat">
                              {{ tr_inv.amount_in_vat }}
                            </vs-td>

                          </vs-tr>
                        </template>

                      </vs-table>

                      <vs-table class="mt-8" :data="data[indextr].add_cost">

                        <template slot="header">
                          <h5 class="mb-4">Additional cost</h5>
                        </template>

                        <template slot="thead">
                          <vs-th>NAME</vs-th>
                          <vs-th>NOMINAL CODE</vs-th>
                          <vs-th>SAGE DEPARTMENT</vs-th>
                          <vs-th>AMOUNT (Excl VAT) in {{ account_currency }}</vs-th>
                          <vs-th>AMOUNT (Incl VAT) in {{ account_currency }}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :key="index_cost" v-for="(tr_cost, index_cost) in data">

                            <vs-td :data="tr_cost.name">
                              {{ tr_cost.name }}
                            </vs-td>

                            <vs-td>
                              {{ tr_cost.sage_nominal_code.code || 'N/A' }}
                            </vs-td>

                            <vs-td>
                              {{ tr_cost.sage_department.name || 'N/A' }}
                            </vs-td>

                            <vs-td :data="tr_cost.amount_ex_vat">
                              {{ tr_cost.amount_ex_vat }}
                            </vs-td>

                            <vs-td :data="tr_cost.amount_in_vat">
                              {{ tr_cost.amount_in_vat }}
                            </vs-td>
                          </vs-tr>
                        </template>

                      </vs-table>
                      <div class="vx-row mt-8">
                        <div class="vx-col w-full">
                          <h5>Notes</h5>
                          {{ tr.note || 'N/A' }}
                        </div>
                      </div>
                      <div class="vx-row mt-8 text-primary">
                        <div class="vx-col w-1/2 float-right font-bold">
                          Total invoice value ({{ account_currency }}) : {{calculateTotalInvoiceAmount(data[indextr].items, data[indextr].add_cost)}}
                        </div>
                      </div>
                    </div>
                  </template>
                </vs-tr>
              </template>

            </vs-table>
          </vx-card>
        </div>
      </div>

      <div class="vx-row" v-if="dataLoaded">
        <div v-if="orderDetails.created_credit_note.length > 0 || orderDetails.applyed_credit_note.length > 0" class="vx-col w-full md:mb-0">
          <vx-card  class="mt-8" title="Credit notes">
            <vs-table noDataText="" stripe :data="orderDetails.created_credit_note">

              <template slot="header">
                Created credit note
              </template>

              <template slot="thead">
                <vs-th width="15%">CREDIT NOTE CODE</vs-th>
                <vs-th width="15%">DATE</vs-th>
                <vs-th width="15%">CREDIT AMOUNT (Excl vat/tax in {{ account_currency }})</vs-th>
                <vs-th width="15%">REMAINING CREDIT AMOUNT (Excl vat/tax in {{ account_currency }})</vs-th>
                <vs-th width="25%">NOTE</vs-th>
                <vs-th width="15%">STATUS</vs-th>
                <vs-th width="15%">ACTIONS</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td>
                    <vs-td>
                      <a class="cursor-pointer" @click="onClickViewCreditNote(tr.id)">
                        {{ tr.credit_note_code }}
                      </a>
                    </vs-td>
                  </vs-td>

                  <vs-td>
                    {{ __dateTimeFormatter(tr.created_at) }}
                  </vs-td>

                  <vs-td>
                    {{ Number(tr.credit_amount).toFixed(2) }}
                  </vs-td>

                  <vs-td>
                    {{ Number(tr.remaining_credit_amount).toFixed(2) }}
                  </vs-td>

                  <vs-td>
                    {{ tr.note ||'N/A' }}
                  </vs-td>

                  <vs-td>
                    <vs-chip style="border-radius: 0" class="text-center text-xs" transparent :color="tr.status === 'Active' ? 'primary' : 'danger'">
                      {{ tr.status }}
                    </vs-chip>
                  </vs-td>
                  <vs-td>
                    <vx-tooltip class="ml-2" text="View Credit Note Email Logs" position="top">
                        <vs-button @click.stop="onClickViewCreditNoteEmailLogs(tr.id)"
                                   size="small" color="danger" type="filled" icon-pack="feather" icon="icon-list"></vs-button>
                      </vx-tooltip>
                  </vs-td>


                </vs-tr>
              </template>

            </vs-table>
            <vs-table v-if="orderDetails.applyed_credit_note.length > 0" noDataText="" stripe :data="orderDetails.applyed_credit_note">

              <template slot="header">
                Applied credit note
              </template>

              <template slot="thead">
                <vs-th width="10%">CREDIT NOTE CODE</vs-th>
                <vs-th width="15%">DATE</vs-th>
                <vs-th width="10%">APPLIED CREDIT AMOUNT (Excl vat/tax in {{ account_currency }})</vs-th>
                <vs-th width="20%">NOTE</vs-th>
                <vs-th width="10%">STATUS</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td>
                    <a class="cursor-pointer" @click="onClickViewCreditNote(tr.id)">{{ tr.credit_note_code }}</a>
                  </vs-td>

                  <vs-td>
                    {{ __dateTimeFormatter(tr.created_at) }}
                  </vs-td>

                  <vs-td>
                    {{ Number(tr.pivot.amount).toFixed(2) }}
                  </vs-td>

                  <vs-td>
                    {{ tr.note }}
                  </vs-td>

                  <vs-td>
                    <vs-chip style="border-radius: 0" class="text-center text-xs" transparent :color="tr.status === 'Active' ? 'primary' : 'danger'">
                      {{ tr.status }}
                    </vs-chip>
                  </vs-td>


                </vs-tr>
              </template>

            </vs-table>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full md:mb-0">
          <vx-card v-if="dataLoaded" class="mt-8" title="Value Added Moments">
            <template slot="actions">
                <div class="flex">
                  <vs-button @click.stop="onClickCreateVam" icon-pack="feather" icon="icon-plus" size="small"
                      class="mr-4" color="primary" type="filled">create</vs-button>
                </div>
            </template>

            <vs-table noDataText="" stripe :data="value_added_moments">

              <template slot="thead">
                <vs-th width="20%">CODE</vs-th>
                <vs-th width="10%">CREATED DATE</vs-th>
                <vs-th width="20%">DESCRIPTION</vs-th>
                <vs-th width="40%">TYPE(S)</vs-th>
                <!-- <vs-th width="20%">REASON CODE</vs-th> -->
                <vs-th width="10%">VALUE TO CUSTOMER</vs-th>
                <vs-th width="10%">COST TO COMPANY</vs-th>
                <vs-th width="10%"></vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td>
                    {{ tr.code }}
                  </vs-td>

                  <vs-td>
                    {{ __dateTimeFormatter(tr.created_at) }}
                  </vs-td>

                  <vs-td>
                    {{ tr.description }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].type.map(type => type).join(", ") }}
                  </vs-td>

                  <!-- <vs-td>
                    {{ tr.reason || '' }}
                  </vs-td> -->

                  <vs-td>
                    {{ tr.value_to_customer || 'N/A' }}
                  </vs-td>

                  <vs-td>
                    {{ tr.cost_to_company || 'N/A' }}
                  </vs-td>
                  
                  <vs-td>
                    <div class="justify-start vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdateVam(tr.id)" class="ml-3" size="small" color="warning"
                          type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Delete" position="left">
                        <vs-button @click.stop="openConfirmDeleteVam(tr.id)" class="ml-3" size="small" color="danger"
                          type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
          </vx-card>
        </div>
      </div>

    </div>
    <vs-prompt
      @cancel="customer_email=''"
      @accept="sendOrderConfirmationEmail"
      @close="activeSendPrompt = false"
      :title="'Select customer user email to send'"
      :accept-text="'Confirm'"
      :color="'primary'"
      :active.sync="activeSendPrompt">
      <div class="con-exemple-prompt">
        <span>Select user email</span>
        <v-select
          :clearable="true" name="customerId" placeholder=""
          v-model="customer_email"
          label="email"
          :options="customer_list"
          :reduce="option => option.email"
          :dir="$vs.rtl ? 'rtl' : 'ltr'">
          <template v-slot:option="option">
              <span>{{option.email}} ( {{option.job_title || 'N/A'}} ) </span>
          </template>
          </v-select>
      </div>
    </vs-prompt>
    <update-customer-product-order-pop-up ref="updateCustomerProductOrderPopUp"/>
    <add-additional-cost-pop-up ref="addAdditionalCostPopUp"/>
    <product-order-invoice-document-pop-up ref="productOrderInvoiceDocumentPopUp"/>
    <create-product-order-invoice-pop-up ref="createProductOrderInvoicePopUp"/>
    <update-product-order-invoice-pop-up ref="updateProductOrderInvoicePopUp"/>
    <create-credit-note-from-order-pop-up v-bind:account_currency="account_currency" ref="createCreditNoteFromOrderPopUp"/>
    <product-order-invoice-pdf-pop-up ref="productOrderInvoicePdfPopUp"/>
    <product-order-confirmation-pdf-pop-up ref="productOrderConfirmationPdfPopUp"/>
    <product-order-invoice-email-log-pop-up ref="ProductOrderInvoiceEmailLogPopUp"/>
    <remove-sos-popup ref="removeSosPopup" @submit="onClickRemoveAddCost"/>
    <product-order-confirmation-sent-log-pop-up ref="ProductOrderConfirmationSentLogPopUp"/>
    <UpdateProductOrderItemsPopUp
      :orderInvoices="orderInvoices"
      :account_currency="account_currency"
      v-on:refresh="refreshData"
      ref="updateProductOrderItemsPopUp"/>
    <status-log-pop-up
      ref="salesOrderStatusLogPopUp"
      title="STATUS CHANGE LOGS"
      :columns="salesLogColumns"
      :fetch-fn="fetchSalesOrderLogs">
      <template #rows="{ data }">
        <vs-tr style="cursor: pointer" :key="i" v-for="(_, i) in data">
          <vs-td :data="data[i].created_at">{{ __dateTimeFormatter(data[i].created_at) }}</vs-td>
          <vs-td :data="data[i].causer_name">{{ data[i].causer_name }}</vs-td>
          <vs-td :data="data[i].description">
            <vs-chip transparent :color="data[i].description === 'updated' ? 'warning' : 'primary'">{{ data[i].description }}</vs-chip>
          </vs-td>
          <vs-td class="font-semibold">{{ data[i].properties.old ? data[i].properties.old['status.name'] : '' }}</vs-td>
          <vs-td class="font-semibold">{{ data[i].properties.attributes ? data[i].properties.attributes['status.name'] : '' }}</vs-td>
        </vs-tr>
      </template>
    </status-log-pop-up>
    <ProductOrderConfirmation ref="productOrderConfirmation" @sendEmail="openSalesOrderConfirmationSendPopup"/>
    <create-customer-crm-snapshot-pop-up ref="createCustomerCrmSnapshotPopUp" :customer_id="orderDetails.customer.id" />
    <view-sales-order-invoice-log-pop-up ref="viewSalesOrderInvoiceLogPopUp"/>
    <sales-order-invoice ref="salesOrderInvoice" @refreshData="refreshData"/>
     <view-sales-order-log-pop-up ref="viewSalesOrderLogPopUp"/>
     <credit-note-email-log-pop-up ref="creditNoteEmailLogPopUp"/>
     <clone-product-order-pop-up ref="cloneProductOrderPopUp" @refresh="refreshData"/>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

const CustomerRepository = RepositoryFactory.get('customer')
const SageRepository = RepositoryFactory.get('sage')
const DropDownRepository = RepositoryFactory.get('drop_down')
const CrmRepository = RepositoryFactory.get('crm');
const ActivityRepository = RepositoryFactory.get('activity')

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Utils from '@/mixins/Utils'
import ProductOrderTable from './ProductOrderTable'
import UpdateCustomerProductOrderPopUp
  from '@/components/popups/customer/product-orders/UpdateCustomerProductOrderPopUp'
import AddAdditionalCostPopUp from "@/components/popups/customer/product-orders/AddAdditionalCostPopUp";
import ProductOrderInvoiceDocumentPopUp
  from "@/components/popups/customer/product-orders/documents/ProductOrderInvoiceDocumentPopUp";
import CreateProductOrderInvoicePopUp
  from "@/components/popups/customer/product-orders/invoices/CreateProductOrderInvoicePopUp";
import UpdateProductOrderInvoicePopUp
  from "@/components/popups/customer/product-orders/invoices/UpdateProductOrderInvoicePopUp";
import {product_order_statuses} from '@/constants/statuses'
import CreateCreditNoteFromOrderPopUp
  from "@/components/popups/customer/product-orders/credit-note/CreateCreditNoteFromOrderPopUp";
import ProductOrderInvoicePdfPopUp
  from "@/components/popups/customer/product-orders/invoices/ProductOrderInvoicePdfPopUp";
import ProductOrderConfirmationPdfPopUp
  from "@/components/popups/customer/product-orders/order-confirmation/ProductOrderConfirmationPdfPopUp";
import moment from "moment/moment";
import ProductOrderInvoiceEmailLogPopUp
  from "@/components/popups/customer/product-orders/invoices/ProductOrderInvoiceEmailLogPopUp";
import ProductOrderConfirmationSentLogPopUp
  from "@/components/popups/customer/product-orders/ProductOrderConfirmationSentLogPopUp";
import SalesOrderInvoice from '@/components/popups/pdf/SalesOrderInvoice.vue';
import UpdateProductOrderItemsPopUp from "@/components/popups/customer/product-orders/UpdateProductOrderItemsPopUp";
import StatusLogPopUp from "@/components/popups/activity-logs/StatusLogPopUp.vue";
import ProductOrderConfirmation from '@/components/popups/pdf/ProductOrderConfirmation.vue'
import RemoveSosPopup from '@/components/popups/customer/product-orders/RemoveSosPopup.vue'
import CreateCustomerCrmSnapshotPopUp from '@/components/popups/crm/customer/snapshots/CreateCustomerCrmSnapshotPopUp.vue'
import ViewSalesOrderInvoiceLogPopUp from '@/components/popups/customer/product-orders/invoices/ViewSalesOrderInvoiceLogPopUp.vue'
import ViewSalesOrderLogPopUp from '@/components/popups/customer/product-orders/order-log/ViewSalesOrderLogPopUp.vue'
import CreditNoteEmailLogPopUp from "@/components/popups/customer/product-orders/credit-note/CreditNoteEmailLogPopUp";
import CloneProductOrderPopUp from "@/components/popups/customer/product-orders/CloneProductOrderPopUp.vue";
import vSelect from 'vue-select'

export default {
  name: "ProductOrderDetailsView",
  components: {
    ProductOrderConfirmationSentLogPopUp,
    ProductOrderInvoiceEmailLogPopUp,
    ProductOrderTable,
    UpdateCustomerProductOrderPopUp,
    ProductOrderInvoiceDocumentPopUp,
    AddAdditionalCostPopUp,
    CreateProductOrderInvoicePopUp,
    UpdateProductOrderInvoicePopUp,
    flatPickr,
    CreateCreditNoteFromOrderPopUp,
    ProductOrderInvoicePdfPopUp,
    ProductOrderConfirmationPdfPopUp,
    UpdateProductOrderItemsPopUp,
    StatusLogPopUp,
    ProductOrderConfirmation,
    RemoveSosPopup,
    'v-select': vSelect,
    CreateCustomerCrmSnapshotPopUp,
    ViewSalesOrderInvoiceLogPopUp,
    SalesOrderInvoice,
    ViewSalesOrderLogPopUp,
    CreditNoteEmailLogPopUp,
    CloneProductOrderPopUp,
  },
  data: function () {
    return {
      orderDetails: {
        add_costs: [],
        customer: {
          id: null
        }
      },
      id: '',
      dataLoaded: false,
      account_currency: 'GBP',
      product_order_statuses: product_order_statuses,
      orderInvoices: [],
      showPendingButton:true,
      confirmationEmailAlreadySent:false,
      activeSendPrompt: false,
      customer_email: '',
      customer_list: [],
      value_added_moments: [],
      salesLogColumns: [
        { label: 'DATE/TIME',       width: '20%' },
        { label: 'USER',            width: '20%' },
        { label: 'CHANGE TYPE',     width: '20%' },
        { label: 'PREVIOUS STATUS', width: '20%' },
        { label: 'UPDATED STATUS',  width: '20%' },
      ],
      shipmentDate: '',
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Utils],
  async mounted() {
    this.id = this.$route.params.id
    await this.getProductOrderDetails()
    await this.getProductOrderConfirmationSentList()
  },
  methods: {
    async fetchSalesOrderLogs(id, page, perPage) {
      const { data } = await ActivityRepository.getSalesOrderStatusLog(id, page, perPage)
      return { logs: data.data || [], meta: data }
    },
    onClickBack() {
      this.$router.push({path: `/pages/product-orders`})
    },
    handleSosRemoved() {
      // Refresh your data
    },
    async sendOrderConfirmation() {

      this.$refs.productOrderConfirmation.openPopup(this.id, this.orderDetails.product_order_code)
      // await this.$refs.productOrderConfirmationPdfPopUp.openPopup(
      //   this.id,
      //   this.orderDetails.product_order_code,
      //   'paid',
      //   this.orderDetails.account_credit_type === 'proforma',
      //   this.orderDetails.product_order_secret_code
      // )
    },

    async openSalesOrderConfirmationSendPopup(){
      try {
          const { data } = (await DropDownRepository.getCustomerUsersDropdownList(this.orderDetails.customer.id)).data
          this.customer_list = data
          this.activeSendPrompt = true
        } catch (e) {
        }
    },

    async sendOrderConfirmationEmail(){
      try{
        await CustomerRepository.orderConfirmationSentCustomer(this.id, { user_email: this.customer_email})
      }catch(e){
        //
      }
    },
    async onClickViewCreditNoteEmailLogs(id) {
      await this.$refs.creditNoteEmailLogPopUp.openPopup(id)
    },
    shouldShowCancelButton(row) {
      const status = row.status.name
      const accountType = row.customer_account_type
      if (accountType === "credit" && status === "Sent") {
        return false
      }
      if (accountType === "proforma" && status === "Paid") {
        return false
      }
      return ["In Draft", "Overdue", "Sent"].includes(status)
    },
    onClickViewCreditNote(id) {
      let customer_id = this.orderDetails.customer.id
      this.$router.push({path: `/pages/manage-nimble/customers/${customer_id}?step=6&open=${id}`})
    },
    viewConfirmationSentLog(){
      this.$refs.ProductOrderConfirmationSentLogPopUp.openPopUp(this.id)
    },
    onClickViewEmailLog(id) {
      this.$refs.ProductOrderInvoiceEmailLogPopUp.openPopUp(id)
    },
    async onClickViewInvoiceLogs(id, code) {
      await this.$refs.viewSalesOrderInvoiceLogPopUp.openPopup(id, code)
    },
    onClickRemoveSOSPopUp(id) {
      this.$refs.removeSosPopup.openPopup(id) 
    },
    async refreshData() {
      this.getProductOrderDetailsView()
      await this.getProductOrderConfirmationSentList()
    },
    async onClickUpdateOrderItems() {
      await this.$refs.updateProductOrderItemsPopUp.openPopup(this.id, this.orderDetails.customer.id)
    },
    async getProductOrderConfirmationSentList(){
      const {data} = await CustomerRepository.getProductOrderConfirmationSentLog(this.id)
      if(data.data.length !== 0){
        this.confirmationEmailAlreadySent = true
      }
    },
    async onClickStatusChangeConfirm(id, status) {

      if(this.orderDetails.account_credit_type === 'proforma' && !this.isIncludedPaidInvoice) {
          this.$vs.dialog({
            color: 'danger',
            title: `Warning`,
            text: 'This is a proforma account and there does not appear to be a paid invoice against this order. ' +
              'It cannot be accepted until there is a paid invoice',
            accept: null,
            acceptText: "Close"
          })
          return
      }

      if(this.orderDetails.customer.status.id !== 7) {
          this.$vs.dialog({
            color: 'warning',
            title: `Warning`,
            text: 'This Customer is not approved' +
              'It cannot be accepted without a Approved account',
            accept: null,
            acceptText: "Close"
          })
          return
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Confirm',
        text: 'Are you sure you want to make this change?',
        accept: this.onChangeProductOrderStatus,
        parameters: [id, status]
      })
    },
    async onChangeProductOrderStatus(params) {
      await this.$vs.loading({
        container: '#product-order-details-view',
        scale: 0.45
      })
      try {
        await CustomerRepository.statusChangeCustomerProductOrders(params[0], params[1])
        this.showSuccessMessage('Status change successfully!')
        await this.getProductOrderDetails()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#product-order-details-view > .con-vs-loading')
    },

    async getProductOrderDetails() {
      await this.$vs.loading({
        container: '#product-order-details-view',
        scale: 0.45
      })
      try {
       this.orderDetails = (await CustomerRepository.getCustomerProductOrder(this.id)).data.data
      // Map the add_costs array to add is_removed: false to each item
      this.orderDetails.add_costs = this.orderDetails.add_costs.map((x) => {
        return {
          ...x,
          is_removed: false
        }
        })
        if(this.$can('view-invoice')) {
          this.orderInvoices = (await CustomerRepository.getProductOrderInvoices(this.id)).data.data
        }
        this.shipmentDate = this.getShipmentDate()
        this.account_currency = this.orderDetails.customer.account_currency
        this.value_added_moments = this.orderDetails.value_aded_moments
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#product-order-details-view > .con-vs-loading')
      this.dataLoaded = true
    },

    getShipmentDate(){
      if (!this.orderDetails.formulation_items.length) {
        return ''
      } 
      else {
        const firstDate = this.orderDetails.formulation_items[0].shipment_date
        return this.orderDetails.formulation_items.every(
          item => item.shipment_date === firstDate
        ) ? firstDate : 'Multiple'
      }
    },

    async getProductOrderDetailsView() {
      await this.getProductOrderDetails()
    },

    async onClickProductOrderUpdate(id, customerId) {
      await this.$refs.updateCustomerProductOrderPopUp.openPopup(id, customerId)
    },
    async onClickCloneProductOrder() {
      await this.$refs.cloneProductOrderPopUp.openPopup(this.orderDetails)
    },

    async onChangeOrderStatusHandle() {
      await this.$vs.loading({
        container: '#product-order-details-view',
        scale: 0.45
      })
      try {
        await CustomerRepository.changeRmOrderHandleType(this.id)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#product-order-details-view > .con-vs-loading')
    },

    productOrderStatusColorFactory() {
      const status = this.product_order_statuses.find((n) => n.name === this.orderDetails.status.name)
      return status ? status.color : 'dark'
    },

    async onClickCreateInvoice() {
      await this.$refs.createProductOrderInvoicePopUp
        .openPopup(this.id, this.orderDetails.product_order_code, this.account_currency, this.orderDetails.formulation_items, this.orderInvoices, this.orderDetails.created_credit_note, this.orderDetails.note)
    },
    async onClickUpdateInvoice(data) {
      await this.$refs.updateProductOrderInvoicePopUp.openPopup(this.id,this.orderDetails.product_order_code, this.account_currency, this.orderDetails.formulation_items, data, this.orderInvoices, this.orderDetails.created_credit_note)
    },
    async onChangeInvoiceDate() {
      await this.$vs.loading({
        container: '#product-order-details-view',
        scale: 0.45
      })
      let payload = []
      Object.assign(payload, this.orderDetails.additional_cost)
      payload = payload.map((x) => {
        return { name: x.name, amount: x.amount }
      })
      await CustomerRepository.addAdditionalCostToProductOrder(this.id, {invoice_date: this.orderDetails.invoice_date, additional_cost: payload})
      this.$vs.loading.close('#product-order-details-view > .con-vs-loading')
      await this.refreshData()
    },
    async onClickInvoiceView(id) {
      await this.$refs.productOrderInvoiceDocumentPopUp.openPopup(id, this.orderDetails.product_order_code)
    },
    async onClickInvoiceViewTest(id, status_name, secret_code, last_email_sent_at) {

      this.$refs.salesOrderInvoice.openPopup(
          id,
          this.orderDetails.product_order_code,
          status_name,
          last_email_sent_at !== '',
          this.orderDetails.customer.id, 
        )
      // await this.$refs.productOrderInvoicePdfPopUp.openPopup(
      //   id,
      //   this.orderDetails.product_order_code,
      //   status_name,
      //   this.orderDetails.account_credit_type === 'proforma',
      //   secret_code,
      //   last_email_sent_at !== ''
      // )
    },
    invoiceStatusColorFactory(status) {
      switch (status) {
        case 'Pending':
          return 'warning'
        case 'Paid':
          return 'primary'
        case 'Refunded':
          return 'warning'
        case 'Cancelled':
          return 'danger'
      }
    },
    convertDate(date){
      return moment(date).format('DD/MM/YYYY')
    },
    async onClickConfirmStatusChange(id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: `Confirm`,
          text: 'Are you sure you want to change the status ?',
          accept: this.onClickUpdateInvoiceStatus,
          parameters: [id, status]
        })
    },
    async onClickUpdateInvoiceStatus(params) {
      await this.$vs.loading({
        container: '#product-order-details-view',
        scale: 0.45
      })
      try {
        await CustomerRepository.invoiceStatusChange(params[0], params[1])
        await this.getProductOrderDetails()
        this.showSuccessMessage('Invoice status changed successfully!')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#product-order-details-view > .con-vs-loading')
    },
    async onClickCreateSageSalesOrder() {
      await this.$vs.loading({
        container: '#product-order-details-view',
        scale: 0.45
      })
      try {
        let payload = {}
        payload.customer_id = 90537
        payload.document_no = this.orderDetails.customer.company_name
        payload.is_editing = true
        payload.is_to_sequence_lines = true
        payload.lines = this.orderDetails.formulation_items
        await SageRepository.createSalesOrder(payload)
      } catch (e) {
        this.showErrorMessage(e.response.data.data.Message)
      }
      this.$vs.loading.close('#product-order-details-view > .con-vs-loading')
    },
    calculateTotalInvoiceAmount(inv_items, add_cost) {
      const total_inv = Number(inv_items.reduce((a, b) => a + Number(b.amount_ex_vat), 0))
      const total_add_cost = Number(add_cost.reduce((a, b) => a + Number(b.amount_ex_vat), 0))
      return Number(total_inv +  total_add_cost).toFixed(2)
    },
    onClickViewCustomer() {
      this.$router.push(`/pages/manage-nimble/customers/${this.orderDetails.customer.id}`)
    },
    async onClickCreateCreditNote() {
      await this.$refs.createCreditNoteFromOrderPopUp.openPopup(this.orderDetails.id, this.orderDetails.customer.id)
    },
    formatDate(date){
      return
    },
    async onClickViewLogs() {
      await this.$refs.viewSalesOrderLogPopUp.openPopup(this.id, this.orderDetails.product_order_code)
    },
    async onClickViewItemLogs() {
      await this.$refs.salesOrderStatusLogPopUp.openPopup(this.id, { subtitle: this.orderDetails.product_order_code })
    },
    async onClickRemoveAddCost(popupData) {
      try {
        let create_form = {}
          create_form.name =  this.orderDetails.name
          create_form.line1 =  this.orderDetails.line1
          create_form.line2 =  this.orderDetails.line2
          create_form.line3 =  this.orderDetails.line3
          create_form.town_state =  this.orderDetails.town_state
          create_form.post_code =  this.orderDetails.post_code
          create_form.country =  this.orderDetails.country
          create_form.delivery_instruction =  this.orderDetails.delivery_instruction
          create_form.note = this.orderDetails.note
          create_form.customers_order_number =  this.orderDetails.customers_order_number
          create_form.sage_department_id = this.orderDetails.sage_department.id ? this.orderDetails.sage_department.id : null
          create_form.region_id = this.orderDetails.region.id ? this.orderDetails.region.id : null
          create_form.add_costs = this.orderDetails.add_costs.map((x) => {
          const isMatch = x.id === popupData.sosId
          return {
            name: x.name,
            amount: parseFloat(x.amount).toFixed(2),
            vat_percent: parseFloat(x.vat_percent).toFixed(2),
            sage_nominal_code_id: x.sage_nominal_code_id,
            is_removed: isMatch,
            ...(isMatch && {
              removal_meta: {
                staff_id: popupData.authoriser_id,
                reason: popupData.reason_id,
                notes: popupData.notes
              }
            })
          }
        })
        await CustomerRepository.updateCustomerProductOrder(this.id, create_form)
        await this.getProductOrderDetails()
      } catch (error) {
        
      }
    },
    async onClickCreateVam() {
      await this.$refs.createCustomerCrmSnapshotPopUp.openPopup(null, this.orderDetails)
    },
    async onClickUpdateVam(id) {
      await this.$refs.createCustomerCrmSnapshotPopUp.openPopup(id)
    },
    openConfirmDeleteVam(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        acceptText: 'Confirm',
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDeleteVam,
        parameters: [id]
      })
    },
    async onClickDeleteVam(params) {
      try {
        await CrmRepository.deleteCustomerSnapshot(params[0])
        await this.getProductOrderDetailsView()
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
  },
  computed: {
    isAllItemsInAcceptedStatus: function () {
      return this.checkKeyHasAllSameValue(this.orderDetails.formulation_items, 'item_status', 'Submitted')
    },
    isOneItemInAcceptedStatus: function () {
      return this.checkKeyHasOneSameValue(this.orderDetails.formulation_items, 'item_status', 'Pending')
    },
    isOneItemInDispatchedStatus: function () {
      return this.checkKeyHasOneSameValue(this.orderDetails.formulation_items, 'item_status', 'Dispatched')
    },
    isIncludedPaidInvoice: function() {
        if(this.orderInvoices.length === 0) {
          return false
        }
        return this.orderInvoices.some((obj) => { return obj.status.name === 'Paid' })
      },
  },
  watch: {
    async '$route.params.id'(newId, oldId) {
      if (newId && newId !== oldId) {
        this.id = newId
        this.dataLoaded = false
        await this.getProductOrderDetails()
        await this.getProductOrderConfirmationSentList()
      }
    }
  },
}
</script>
<style scoped>
.user-edit-popup >>> .vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup >>> .vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}

table td {
  vertical-align: top;
  min-width: 140px;
  padding-bottom: .8rem;
  word-break: break-all;
}

</style>



